import { GetServerSideProps } from 'next';
import Head from 'next/head';
import previewLetslink from '../../public/preview/preview-letslink.jpg';
import { Footer, Header } from '../../components';
import menu from '../../utils/menu';
import LogisticPage, { LogisticPageProps } from './logistic';
import { getAllArticles } from '../../services/blog.service';

export default function Logistic({ posts }: LogisticPageProps) {
  return (
    <>
      <Head>
        <title>MAVINX | LOGISTIC</title>
        <meta property="og:title" content="MAVINX | LOGISTIC" />
        <meta property="og:image" content={`${previewLetslink.src}`} />
        <meta name="twitter:image" content={`${previewLetslink.src}`} />
        <meta
          property="og:image:alt"
          content="Transportation and Logistics Software Development"
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:description"
          content="Transportation and Logistics Software Development"
        />
        <meta
          name="description"
          content="Transportation and Logistics Software Development"
        />
      </Head>
      <Header appearance="transparent" appearanceLogo="primary" menu={menu} />
      <LogisticPage posts={posts} />
      <Footer />
    </>
  );
}

export const getServerSideProps: GetServerSideProps<
  LogisticPageProps
> = async () => {
  try {
    const posts = await getAllArticles();
    return {
      props: {
        posts,
      },
    };
  } catch {
    return {
      notFound: true,
    };
  }
};
